import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { Constants } from '@base/src/app/models/constants';
import { QRButton } from '@base/src/app/models/qr-button.model';

@Component({
  selector: 'app-electronic-billing-block',
  templateUrl: './electronic-billing-block.component.html',
  styleUrls: ['./electronic-billing-block.component.scss'],
})
export class ElectronicBillingBlockComponent {
  buttonReload: QRButton = {
    hierarchy: QRButton.HIERARCHY_1,
    size: QRButton.SIZE_MEDIUM,
    viewValue: 'Reintentar',
    icon: Constants.ICONS.RELOAD,
  };

  home: QRButton = {
    hierarchy: QRButton.HIERARCHY_3,
    size: QRButton.SIZE_MEDIUM,
    viewValue: 'Ir a la pagina principal',
  };

  constructor(private readonly router: Router) {}

  onReload() {
    window.location.reload();
  }

  onGoHome() {
    this.router.navigate(['/']);
  }
}
